<template>
  <div class="tips">
    <i class="el-icon-info" />
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ content }}</span>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.tips {
  background-color: #fff;
  padding: 16px 60px;
  font-size: 14px;
  border-bottom: 1px solid rgb(236, 236, 236);
}
</style>
